"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableCoordinate = exports.MIN_LONGITUDE = exports.MAX_LONGITUDE = exports.MIN_LATITUDE = exports.MAX_LATITUDE = void 0;
/**
 * The maximum latitude value.
 */
exports.MAX_LATITUDE = 90.0;
/**
 * The minimum latitude value.
 */
exports.MIN_LATITUDE = -90.0;
/**
 * The maximum longitude value.
 */
exports.MAX_LONGITUDE = 180.0;
/**
 * The minimum longitude value.
 */
exports.MIN_LONGITUDE = -180.0;
/**
 * An immutable representation of a Coordinate.
 */
class ImmutableCoordinate {
    constructor(latitude, longitude) {
        if (!isFinite(latitude) || !isFinite(longitude)) {
            throw RangeError('Latitude and longitude must be finite numbers');
        }
        if (latitude > exports.MAX_LATITUDE) {
            throw RangeError(`Latitude must be less than or equal to ${exports.MAX_LATITUDE}`);
        }
        else if (latitude < exports.MIN_LATITUDE) {
            throw RangeError(`Latitude must be greater than or equal to ${exports.MIN_LATITUDE}`);
        }
        if (longitude > exports.MAX_LONGITUDE) {
            throw RangeError(`Longitude must be less than or equal to ${exports.MAX_LATITUDE}`);
        }
        else if (longitude < exports.MIN_LONGITUDE) {
            throw RangeError(`Longitude must be greater than or equal to ${exports.MIN_LATITUDE}`);
        }
        this.latitude = latitude;
        this.longitude = longitude;
    }
}
exports.ImmutableCoordinate = ImmutableCoordinate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29vcmRpbmF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9Db29yZGluYXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ1UsUUFBQSxZQUFZLEdBQUcsSUFBSSxDQUFDO0FBRWpDOztHQUVHO0FBQ1UsUUFBQSxZQUFZLEdBQUcsQ0FBQyxJQUFJLENBQUM7QUFFbEM7O0dBRUc7QUFDVSxRQUFBLGFBQWEsR0FBRyxLQUFLLENBQUM7QUFFbkM7O0dBRUc7QUFDVSxRQUFBLGFBQWEsR0FBRyxDQUFDLEtBQUssQ0FBQztBQW1CcEM7O0dBRUc7QUFDSCxNQUFhLG1CQUFtQjtJQUs1QixZQUFZLFFBQWdCLEVBQUUsU0FBaUI7UUFDM0MsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxTQUFTLENBQUMsRUFBRTtZQUM3QyxNQUFNLFVBQVUsQ0FBQywrQ0FBK0MsQ0FBQyxDQUFDO1NBQ3JFO1FBRUQsSUFBSSxRQUFRLEdBQUcsb0JBQVksRUFBRTtZQUN6QixNQUFNLFVBQVUsQ0FBQywwQ0FBMEMsb0JBQVksRUFBRSxDQUFDLENBQUM7U0FDOUU7YUFBTSxJQUFJLFFBQVEsR0FBRyxvQkFBWSxFQUFFO1lBQ2hDLE1BQU0sVUFBVSxDQUFDLDZDQUE2QyxvQkFBWSxFQUFFLENBQUMsQ0FBQztTQUNqRjtRQUVELElBQUksU0FBUyxHQUFHLHFCQUFhLEVBQUU7WUFDM0IsTUFBTSxVQUFVLENBQUMsMkNBQTJDLG9CQUFZLEVBQUUsQ0FBQyxDQUFDO1NBQy9FO2FBQU0sSUFBSSxTQUFTLEdBQUcscUJBQWEsRUFBRTtZQUNsQyxNQUFNLFVBQVUsQ0FBQyw4Q0FBOEMsb0JBQVksRUFBRSxDQUFDLENBQUM7U0FDbEY7UUFFRCxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixJQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQztJQUMvQixDQUFDO0NBQ0o7QUF6QkQsa0RBeUJDIn0=